import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { tonePillClass } from "@/lib/tone";

import type { TtuAttention } from "../api";
import { parseAttentionDeepLink, severityTone } from "../format";

export function AttentionList({ items, limit, seeAll = false, search = {} }: { items: TtuAttention[]; limit?: number; seeAll?: boolean; search?: Record<string, unknown> }) {
  const shown = typeof limit === "number" ? items.slice(0, limit) : items;
  return <Card><CardContent className="grid gap-3">
    <div className="flex items-center justify-between"><h2 className="text-base font-semibold text-ks-ink">Needs attention{limit ? " (top 3)" : ""}</h2>{seeAll && <Link data-nonmutating to="/app/$area/$module/$tab" params={{ area: "customer_acquisition", module: "meteoric_units_sold", tab: "traffic" }} search={search}>See all</Link>}</div>
    {shown.length ? <ul className="divide-y divide-border">{shown.map((item) => {
      const target = parseAttentionDeepLink(item.deep_link, search);
      const tone = severityTone(item.severity);
      return <li key={`${item.step}-${item.headline}`}><Link data-nonmutating to="/app/$area/$module/$tab" params={{ area: "customer_acquisition", module: "meteoric_units_sold", tab: target.tab }} search={target.search} className="flex items-center gap-3 py-3 text-sm">
        <span aria-hidden className={tone === "critical" ? "size-2 rounded-full bg-ks-fail" : tone === "watch" ? "size-2 rounded-full bg-ks-warn" : "size-2 rounded-full bg-ks-grey-2"} />
        <Badge variant="outline" className={tonePillClass(tone)}>{item.severity}</Badge>
        <span>{item.headline}</span><span className="ml-auto tabular-nums">{item.units_effect > 0 ? "+" : ""}{item.units_effect} units</span><ChevronRight aria-hidden className="size-4 text-muted-foreground" />
      </Link></li>;
    })}</ul> : <p className="text-sm text-muted-foreground">Nothing needs attention for this view.</p>}
  </CardContent></Card>;
}
